<h2>LCB Segurança</h2>

<app-table
  [headers]="headers"
  [content]="filaList"
  [showFilter]="true"
  [hasEdit]="true"
  (editing)="edit($event)"
>
</app-table>
